import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { premiumFeaturesService } from '@/services/api/premiumFeatures.service'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

async function getPremiumFeatures() {
  const response = await premiumFeaturesService.getPremiumFeatures()
  return response.data
}

export function useGetPremiumFeatures() {
  const { isAuthenticated } = useCognitoAuth()

  return useQuery({
    queryKey: [QUERY_KEYS.permissions.getPremiumFeatures],
    queryFn: () => getPremiumFeatures(),
    enabled: isAuthenticated,
  })
}
